import * as React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

import styles from './Loader.module.css';
import { useChatTranslation } from 'hooks/useChatTranslation';

interface LoaderProps {
  text?: string;
}

export const Loader = ({ text }: LoaderProps) => {
  const { t } = useChatTranslation();

  return (
    <div className={styles['container']}>
      <div className={styles['loader']}>
        <DotLottieReact src="/static/animations/three-dots.lottie" loop autoplay themeId="blue" />
      </div>
      {text || t('Thinking')}
    </div>
  );
};
